<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      top
      elevation="24"
      style="margin-top: 65px;"

    >
      Selected records have been attached!

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo lighten-2"
          text
          v-bind="attrs"
          @click="snackbar = false"
          fab
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Select Records</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-container fluid class="mt-6">
            <v-row>
              <v-col offset="1" cols="10">
                <v-row>
                  <v-col cols="4" offset="8">
                    <v-text-field
                      v-model="search"
                      placeholder="Search record"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <RecordsViewList
                      :viewMode="viewMode"
                      :search="search"
                      :routeAccess="true"
                      :routeId="routeId"
                      :routeType="routeType"
                      :subRouteIndex="subRouteIndex"
                      :parentRouteId="parentRouteId"
                      :requestId="requestId"
                      @showSnackbar="showSnackbar"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import RecordsViewList from "./RecordsViewList";

export default {
  name: "AttachRecordModal",
  components: {
    RecordsViewList,
  },
  props: {
    dialog: Boolean,
    routeId: Number,
    routeType: String,
    subRouteIndex: Number,
    parentRouteId: String,
    requestId: Number,
  },
  data() {
    return {
      search: "",
      viewMode: "",
      snackbar: false,
    };
  },
  methods: {
    ...mapActions(["fetchUnsortedFiles"]),
    close() {
      this.$emit("closeDialog", false);
    },
    showSnackbar() {
      this.snackbar = true;
      this.close();
    }
  },
  created() {
    this.fetchUnsortedFiles();
  },
  watch: {
    dialog: function () {
      if (this.dialog) this.viewMode = "list";
      else this.viewMode = "";
    },
  },
};
</script>

<style>
</style>